import { CompanyTheme } from '../../api/types';
import DayjsRangePicker from '../../components/DayjsRangePicker';
import CheckboxField from '../../components/fields/CheckboxField';
import PhoneAndPrefixField from '../../components/fields/ci/PhoneField';
import CountryField from '../../components/fields/CountryField';
import DatePickerField from '../../components/fields/DatePickerField';
import DisplayField from '../../components/fields/DisplayField';
import DisplayFieldWithUTCOffset from '../../components/fields/DisplayFieldWithUTCOffset';
import FixedRangePickerField from '../../components/fields/FixedRangePickerField';
import GenderField from '../../components/fields/GenderField';
import IdentityNumberField from '../../components/fields/IdentityNumberField';
import InputNumberField from '../../components/fields/InputNumberField';
import MaritalStatusField from '../../components/fields/MaritalStatusField';
import MultipleDraggerField from '../../components/fields/MultipleDraggerField';
import NationalityField from '../../components/fields/NationalityField';
import RaceField from '../../components/fields/RaceField';
import RangePickerField from '../../components/fields/RangePickerField';
import RegionField from '../../components/fields/RegionField';
import ResidentialStatusField from '../../components/fields/ResidentialStatusField';
import SelectField from '../../components/fields/SelectField';
import SwitchField from '../../components/fields/SwitchField';
import TimePickerField from '../../components/fields/TimePickerField';
import TranslatedInputField from '../../components/fields/TranslatedInputField';
import VehicleCarousel from '../../components/Images';
import PaginatedTableWithContext from '../../components/PaginatedTableWithContext';
import TimePicker from '../../components/TimePickerField';
import type { ThemeComponents } from '../context';
import Anchor from '../default/Anchor';
import ArrowDownIcon from '../default/ArrowDownIcon';
import BackButton from '../default/BackButton';
import Button from '../default/Button';
import Calculator from '../default/Calculator';
import CardWithHeader from '../default/CardWithHeader';
import Checkbox from '../default/Checkbox';
import CloseButton from '../default/CloseButton';
import ComparisonButton from '../default/ComparisonButton';
import ConfiguratorDepositDisplay from '../default/Configurator/DepositDisplay';
import ConfiguratorLayout from '../default/Configurator/Layout';
import ConfiguratorMessageButton from '../default/Configurator/MessageButton';
import ConfiguratorSubHeader from '../default/Configurator/SubHeader';
import ConsentModal from '../default/ConsentModal';
import LegalText from '../default/ConsentsAndDeclarations/LegalText';
import Dropdown from '../default/Dropdown';
import ErrorMessageBox from '../default/ErrorMessageBox';
import InputField from '../default/Fields/InputField';
import PasswordField from '../default/Fields/PasswordField';
import FinderLayout from '../default/Finder/Layout';
import InfoMessageBox from '../default/InfoMessageBox';
import Input from '../default/Input';
import JourneySteps from '../default/JourneySteps';
import ListItem from '../default/ListItem';
import LoadingSpinner from '../default/LoadingSpinner';
import MobilityWebpageLayout from '../default/Mobility/WebPageLayout';
import Modal from '../default/Modal';
import notification from '../default/notification';
import PageWithHeader from '../default/PageWithHeader';
import Popconfirm from '../default/Popconfirm';
import Radio from '../default/Radio';
import Search from '../default/Search';
import Select from '../default/Select';
import StandardLayout from '../default/Standard/Layout';
import Steps from '../default/Steps';
import Tabs from '../default/Tabs';
import Title from '../default/Title';
import Tooltip from '../default/Tooltip';
import WarningMessageBox from '../default/WarningMessageBox';
import makeThemeComponents from '../makeThemeComponents';
import PorscheCarousel from '../porsche/Carousel';
import CheckboxGroup from '../volkswagen/CheckboxGroup';
import ConfiguratorDropdown from '../volkswagen/Configurator/Dropdown';
import CupraGlobalStyles from './CupraGlobalStyles';

const CupraTheme: ThemeComponents = {
    theme: CompanyTheme.Cupra,
    gutter: {
        testDriveModal: [14, 14],
    },
    Input,
    PageWithHeader,
    Dropdown,
    ConfiguratorDropdown,
    Select,
    ConfiguratorLayout,
    ConfiguratorSubHeader,
    ConfiguratorMessageButton,
    ConfiguratorDepositDisplay,
    Button,
    Title,
    Checkbox,
    CheckboxGroup,
    RangePicker: DayjsRangePicker,
    StandardLayout,
    MobilityWebpageLayout,
    BackButton,
    CloseButton,
    ComparisonButton,
    FinderLayout,
    TimePicker,
    FormFields: {
        RangePickerField,
        FixedRangePickerField,
        SelectField,
        DatePickerField,
        InputField,
        InputNumberField,
        IdentityNumberField,
        NationalityField,
        PhoneAndPrefixField,
        RegionField,
        CountryField,
        MultipleDraggerField,
        TimePickerField,
        RaceField,
        GenderField,
        ResidentialStatusField,
        MaritalStatusField,
        CheckboxField,
        SwitchField,
        TranslatedInputField,
        DisplayField,
        PasswordField,
        DisplayFieldWithUTCOffset,
    },
    LoadingSpinner,
    Modal,
    ConsentModal,
    notification,
    Radio,
    RadioGroup: Radio.Group,
    CardWithHeader,
    Steps,
    Search,
    ErrorMessageBox,
    WarningMessageBox,
    JourneySteps,
    PaginatedTableWithContext,
    Popconfirm,
    Carousel: PorscheCarousel,
    InfoMessageBox,
    Tooltip,
    Calculator,
    ListItem,
    Tabs,
    Anchor,
    LegalText,
    ArrowDownIcon,
    VehicleCarousel,
};

export default makeThemeComponents('CupraThemeProvider', CupraTheme, CupraGlobalStyles);
